var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02953 6.97089C8.48346 6.42504 7.74297 6.11841 6.97087 6.11841C6.19877 6.11841 5.45827 6.42504 4.9122 6.97089L2.85287 9.02955C2.30678 9.57563 2 10.3163 2 11.0886C2 11.8608 2.30678 12.6015 2.85287 13.1476C3.39895 13.6936 4.13959 14.0004 4.91187 14.0004C5.68414 14.0004 6.42479 13.6936 6.97087 13.1476L8.0002 12.1182",
    stroke: "#7D899D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9707 9.02953C7.51677 9.57538 8.25727 9.88201 9.02937 9.88201C9.80147 9.88201 10.542 9.57538 11.088 9.02953L13.1474 6.97087C13.6935 6.42479 14.0002 5.68414 14.0002 4.91187C14.0002 4.13959 13.6935 3.39895 13.1474 2.85287C12.6013 2.30678 11.8606 2 11.0884 2C10.3161 2 9.57545 2.30678 9.02937 2.85287L8.00004 3.8822",
    stroke: "#7D899D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.ba702df5ef9616d19b45c5f3661e7682.svg";
export { ForwardRef as ReactComponent };